import React from 'react'
import "./welcome.css"
import "../mainPage/mainPage.css"
import desktopCar from "../../images/desktopCar.png"
import desktopVoucher from "../../images/desktopVoucher.png"
import desktopGlass from "../../images/desktopGlass.png"
import desktopGarden from "../../images/desktopGarden.png"

const Welcome = () => {
    return (
        <div className="content">

            <div>
                <img src={desktopCar} className="carImage" />
                <div className="textHolder">
                    <div className="textItem">
                        <div>СВАКИХ 14 ДАНА</div>
                        <div>ШКОДА ОКТАВИЈА</div>
                    </div>
                    <div className="textItem">
                        <div>СВАКИХ 7 ДАНА</div>
                        <div>ВАУЧЕР ЗА<br />
                            ОПРЕМАЊЕ КУХИЊЕ
                        </div>
                    </div>
                    <div className="textItem">
                        <div>СВАКОГ ДАНА</div>
                        <div>КУХИЊСКИ ФРИЖИДЕР</div>
                    </div>
                    <div className="textItem">
                        <div>СВАКИХ САТ ВРЕМЕНА</div>
                        <div>СЕТ ЗА РОШТИЉ</div>
                    </div>
                </div>

            </div>


            <div className="prizes">
                <img src={desktopVoucher} className="voucherImage desktopPrizes" />
                <img src={desktopGlass} className="fridgeImage desktopPrizes" />
                <img src={desktopGarden} className="bagImage desktopPrizes" />
            </div>


            <div className="lastTextWelcome">Слике награда не морају одговарати стварним наградама</div>

        </div>
    )
}

export default Welcome